import React, { Component } from 'react';
import CustomSelect from './CustomSelect';
import File from '../../File';
import Button from '../../Button';
import { connect } from "react-redux";
import CreatableSelect from "react-select/creatable";

import { startFormLoading, stopFormLoading } from "../../../store/actions/loader";
import { bindActionCreators } from "redux";
import { onCheckDocument } from '../../../helpers/CommonHelpers';
import { serviceRequestTableLocalTime, onCheckUserCanAccessTheModule } from '../../../helpers/validationHelper';
import moment from 'moment';
import { toast } from 'react-toastify';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import Col from '../../Col';
import Row from '../../Row';
import { USER_ROLES } from '../../../common/constants';

class CreateDeveloperServiceRequest extends Component {
        constructor(props){
            super(props);
            this.state={
            }
        }
    validateExpiry=(value)=>{
            const {subAreasByLocation, onSetEasyWalkThroughFormData, user}=this.props
            let selectedAsset = subAreasByLocation.filter((asset) => asset.assetId === value)[0];
            const startDay=serviceRequestTableLocalTime(moment(),'suitepage')
            const estimatedInOneYeardaysRemaining= moment(selectedAsset.warrantExpiration).diff(startDay, 'days')
            const inOneYeardaysRemaining= estimatedInOneYeardaysRemaining - 1
            if(inOneYeardaysRemaining<0 && (user.roles[0].role.name === 'Home Owner' || user.roles[0].role.name === 'Occupant')){
            toast.error(
                ` ⓘ We’re sorry, but ${ selectedAsset.name ? selectedAsset.name:'Selected Asset'} is currently past your warranty end date. Please contact us should you have any questions or concerns regarding your warranty.`,
                { autoClose: 6000, position: "top-center" }
            );
            }else{
            onSetEasyWalkThroughFormData({ assetId: value }) 
            }
    }
     // function to set the selected tags
    setTags = (newValue, actionMeta) => {
        const { onSetEasyWalkThroughFormData } = this.props;
        onSetEasyWalkThroughFormData({
            tags: newValue
        })
    }

    render () {
        const { easyWalkThroughFormData,onSetEasyWalkThroughFormData, types, onSelectIssueType, 
            handleDelete, onSelectImage, updateServiceRequest, onCreateServiceRequest, onChange, subAreasByLocation, locations, user, serviceRequestTags } = this.props;
            // console.log('easyWalkThroughFormData.subAreas --->',easyWalkThroughFormData.subAreas)
            const isEnabled = onCheckUserCanAccessTheModule([USER_ROLES.SUPER_ADMIN,USER_ROLES.ADMIN,USER_ROLES.PROPERTY_DEVELOPER]);
            return (
                <>
            <div className='offlineWalkthroughData__table' style={{marginBottom: 20}}>
            <div className='offlineWalkthroughData__item'>
                <CustomSelect
                    placeholder='Select Location'
                    onChange={(e) => onChange(e)}
                    value={easyWalkThroughFormData.areaId ? easyWalkThroughFormData.areaId : ''}
                    options={locations.length > 0 ? locations.map(a => ({ id: a.areaId, name: a.customLabel ? a.customLabel : a.name })) : []}
                    disabled={easyWalkThroughFormData.serviceRequestId}
                />
            </div>
            <div className='offlineWalkthroughData__item' >
                <CustomSelect
                    placeholder='Select Item'
                    onChange={(e) => this.validateExpiry(e.target.value )}
                    value={easyWalkThroughFormData && easyWalkThroughFormData.assetId ? easyWalkThroughFormData.assetId : ''}
                    options={ subAreasByLocation.length > 0 ?
                        subAreasByLocation.map(s => ({ id: s.assetId, name: s.name })) : []}
                    disabled={easyWalkThroughFormData.serviceRequestId}
                />
            </div>
            {
                user.roles[0].role.name === 'Home Owner'?
            <div className='offlineWalkthroughData__item offlineWalkthroughData__selectItem--padded' >
                General
            </div>
                :  
            <div className='offlineWalkthroughData__item' >
                <CustomSelect
                    placeholder='Select issue type'
                    onChange={(e) => onSelectIssueType(e)}
                    value={easyWalkThroughFormData && easyWalkThroughFormData.issueTypeId ? easyWalkThroughFormData.issueTypeId : ''}
                    options={types && types.length > 0 ? types.map(t => ({ id: t.id, name: t.name })) : []}
                    disabled={easyWalkThroughFormData.serviceRequestId}
                />
            </div>
            }
            <div className='offlineWalkthroughData__textdiv descriptiondiv'>
                <input
                    className='offlineWalkthroughData__selectItem'
                    onChange={(e) => onSetEasyWalkThroughFormData({ description: e.target.value })}
                    placeholder='Add Description'
                    value={easyWalkThroughFormData.description}
                />
            </div>
            <div className='offlineWalkthroughData__item' style={{ width: 100, alignItems: 'center' }}>
                {easyWalkThroughFormData && easyWalkThroughFormData.selectedImage && easyWalkThroughFormData.selectedImage.length > 0 ?
                  easyWalkThroughFormData.selectedImage.map(image => {                      
                    return (
                        easyWalkThroughFormData.selectedImage.length > 1 ? 
                        <div style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                        <img alt="" src={image.preview ? image.preview : image} style={{ width: 40, height: 37, paddingLeft: 10 }} />
                            <div className='offlineWalkthroughData__delete' onClick={() => handleDelete(image)}>
                            <i class="far fa-trash-alt"></i>
                            </div>
                        </div>
                        :
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                            <div style={{ width: 40, height: 37, paddingRight: 10, position: 'relative' }}>
                        <img alt="" src={image.preview ? image.preview : image} style={{ width: 40, height: 37}} />
                        <div className='offlineWalkthroughData__delete' style={{right: 10}} onClick={() => handleDelete(image)}>
                            <i class="far fa-trash-alt"></i>
                            </div>
                        </div>
                           
                        <File
                            onSelect={(file) => onCheckDocument(file) && onSelectImage(file)}
                            files={[]}
                            smallIcon={true}
                            multiSelect={true}
                            type='image'
                        />
                    </div>

                     
                    )
                })
                    : <File
                        onSelect={(file) => onCheckDocument(file) && onSelectImage(file)}
                        files={[]}
                        smallIcon={true}
                        multiSelect={true}
                        type='image'
                    />
                }
            </div>

            {!isEnabled &&
            <div className='offlineWalkthroughData__item' style={{ borderRight: 0, paddingLeft: 20, justifyContent: 'center', alignItems: 'center' }}>
                <Button
                    color={!easyWalkThroughFormData.areaId || !easyWalkThroughFormData.assetId || !easyWalkThroughFormData.issueTypeId || !easyWalkThroughFormData.description ? "grey" : "teal"}
                    label={easyWalkThroughFormData.serviceRequestId ? "UPDATE" : "ADD"}
                    onClick={() => { easyWalkThroughFormData.serviceRequestId ? updateServiceRequest() : onCreateServiceRequest() }}
                    size="small"
                    disabled={!easyWalkThroughFormData.areaId || !easyWalkThroughFormData.assetId || !easyWalkThroughFormData.issueTypeId || !easyWalkThroughFormData.description}
                />
            </div>}
        </div>
        {isEnabled &&
        <Row>
            <div className='createTags'>
            <CreatableSelect
            placeholder="Add or create tags"
            closeMenuOnSelect={false}
            isClearable
            isMulti
            options={
                serviceRequestTags.length > 0
                ? serviceRequestTags.map(item => ({
                    value: item.id,
                    label: item.name
                }))
                : []
            }
            value={
                easyWalkThroughFormData.tags
                ? easyWalkThroughFormData.tags
                : []
            }
            onChange={(newValue, actionMeta) =>
                this.setTags(newValue, actionMeta)
            }
            />
            </div>
            <div className='createTagsButton'>
        <div className='offlineWalkthroughData__item' style={{ borderRight: 0, paddingLeft: 20, justifyContent: 'center', alignItems: 'center', paddingTop:'0', paddingRight:'0px' }}>
                <Button
                    color={!easyWalkThroughFormData.areaId || !easyWalkThroughFormData.assetId || !easyWalkThroughFormData.issueTypeId || !easyWalkThroughFormData.description ? "grey" : "teal"}
                    label={easyWalkThroughFormData.serviceRequestId ? "UPDATE" : "ADD"}
                    onClick={() => { easyWalkThroughFormData.serviceRequestId ? updateServiceRequest() : onCreateServiceRequest() }}
                    size="small"
                    disabled={!easyWalkThroughFormData.areaId || !easyWalkThroughFormData.assetId || !easyWalkThroughFormData.issueTypeId || !easyWalkThroughFormData.description}
                />
            </div>
            </div>
            </Row>}
    </>
        )
    }
}

const mapStateToProps = state => {
    return {
      user: selectAuthenticatedUser(state),
      serviceRequestTags: state.formOptions.serviceRequestTags
    };
  };
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      startFormLoading,
      stopFormLoading
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateDeveloperServiceRequest);
